import { render } from "./NavbarLoggedin.vue?vue&type=template&id=1c60572c"
import script from "./NavbarLoggedin.vue?vue&type=script&lang=js"
export * from "./NavbarLoggedin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__